import PendingApproval from '@lideralia/alife-uikit/dist/molecules/PendingApproval/PendingApproval';
import { CardLegalTerm } from '@lideralia/alife-uikit/dist/organisms/Cards/LegalTerm';
import React from 'react';

export const ModalNotAllowedToSeeTemplate = (props) =>
  // eslint-disable-next-line react/destructuring-assignment
  props.isAdmin ? <CardLegalTerm {...props} /> : <PendingApproval {...props} />;
